import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CustomDropdown from '@components/CustomDropdown';
import { toastError } from '@components/Toast';

import { fetchMarketList } from '@store/actions/MarketAction';
import { fetchSeasonList } from '@store/actions/SeasonAction';
import { getBrands } from '@store/design/action';
import { getAllBrands, getAllSuppliersMaterials } from '@store/reducers';
import { fetchAllSuppliersMaterials } from '@store/supplier/action';

import ApiClient from '@lib/apiClient';

import { addImageSuffix, onErrorImageLoad } from '@utils/Util';

import { BASE_URL } from '@/constants/constant';

import CommonImage from '@/components/CommonImage';

const CreateNewProduct = ({
	collectionId,
	closeModal,
	imageList,
	removeImage,
	addNewDesign,
	setLoader,
	getCollectionImages,
	isRequestForm = ''
}) => {
	const marketList = useSelector((store) => store.marketStore);
	const [selectedCategory, setSelectedCategory] = useState({});
	const [selectedBrand, setSelectedBrand] = useState({});
	const [selectedSeason, setSelectedSeason] = useState({});
	const [selectedMarket, setSelectedMarket] = useState(0);
	const [selectedImageIndex, setSelectedImageIndex] = useState(0);
	const [categoryList, setCategoryList] = useState([]);
	const [selectedFabric, setSelectedFabric] = useState({});
	const [searchFabric, setSearchFabric] = useState('');
	const [refNumber, setRefNumber] = useState('');
	const dispatch = useDispatch();

	let allFabrics = useSelector(getAllSuppliersMaterials);
	allFabrics = allFabrics?.data?.map((item) => {
		return {
			id: item.materialId,
			value: item.name
		};
	});

	let seasonList = useSelector((store) => store.seasonStore);
	seasonList = seasonList.map((item) => {
		return {
			id: item.constant,
			value: item.name
		};
	});

	let brands = useSelector(getAllBrands);
	brands = brands.map((item) => {
		return {
			id: item.id,
			value: item.name
		};
	});

	useEffect(() => {
		if (isRequestForm === 'SUPPLIER') {
			dispatch(getBrands());
			dispatch(fetchSeasonList());
		}
		dispatch(fetchMarketList());
	}, []);

	useEffect(() => {
		dispatch(fetchAllSuppliersMaterials(0, 20, 'FABRIC', 'id,desc', { search: searchFabric }));
	}, [searchFabric]);

	const fetchSubCategories = (productGroupId) => {
		ApiClient.GET('fetchSubCategory', `${productGroupId ? '?productGroupIds=' + productGroupId : ''}`)
			.then((response) => {
				let tmpCategories = [];
				for (let cat of response.data) {
					for (let item of cat.subCategoryResponseList) {
						tmpCategories.push({
							id: item.id,
							constant: item.name,
							value: item.name,
							isPrimary: item.isPrimary
						});
					}
				}
				setCategoryList(tmpCategories);
			})
			.catch((error) => {
				toastError(error.response.data.message);
			});
	};

	useEffect(() => {
		fetchSubCategories(selectedMarket);
	}, [selectedMarket]);

	const createProduct = () => {
		setLoader(true);
		let selectedImageList = imageList.map((item, index) => {
			return {
				documentId: item.id,
				front: selectedImageIndex === index
			};
		});
		let postData = {
			documentDTOList: selectedImageList,
			productSubCategoryId: selectedCategory.id,
			name: selectedCategory.value,
			productGroupId: selectedMarket
		};
		let url = 'addNewProductInCollection';
		if (isRequestForm === 'SUPPLIER') {
			url = `${BASE_URL}/supplier/products/${collectionId}/add`;
			postData.brandId = selectedBrand.id;
			postData.season = selectedSeason.id;
			postData.materialId = selectedFabric.id;
			postData.fabricReferenceNo = refNumber;
		} else {
			postData.collectionId = collectionId;
		}
		ApiClient.POST(url, postData, '', isRequestForm === 'SUPPLIER')
			.then(() => {
				addNewDesign();
				getCollectionImages();
				closeModal();
				setLoader(false);
			})
			.catch((err) => {
				setLoader(false);
				toastError(err.response.data.message);
			});
	};

	const onItemClick = (item) => {
		if (item?.title === 'Category') {
			setSelectedCategory(item);
		}
		if (item?.title === 'Brand') {
			setSelectedBrand(item);
		}
		if (item?.title === 'Season') {
			setSelectedSeason(item);
		}
		if (item?.title === 'Fabric') {
			setSelectedFabric(item);
		}
	};

	const renderMarketList = () => {
		return marketList.map((market, index) => {
			return (
				<option value={market.id} key={`market_${index}`}>
					{market.name}
				</option>
			);
		});
	};

	const onFabricSearch = (value) => {
		setSearchFabric(value);
	};

	const renderImageList = () => {
		return imageList?.map((item, index) => {
			return (
				<div
					className={selectedImageIndex === index ? 'mItem front-image' : 'mItem'}
					key={`design_${index}`}
				>
					<img
						src={`${process.env.PUBLIC_URL}/icons/delete-round-20.svg`}
						alt="delete"
						className="delete-round"
						onClick={() => removeImage(index)}
					/>
					<img
						src={addImageSuffix(item.docUrl, '')}
						onError={(e) => onErrorImageLoad(e, item.docUrl)}
						className="design-image"
					/>
					<img
						src={`${process.env.PUBLIC_URL}/icons/front-select.svg`}
						alt="select front"
						className="front-select"
						onClick={() => setSelectedImageIndex(index)}
					/>
				</div>
			);
		});
	};

	return (
		<div className="selected-style-images shadow-24dp">
			<div className="selected-title">
				<p className="regular-12 gray_dark_01">Selected photos</p>
			</div>
			<div className="close-icon cursor-pointer position-absolute right-2 top-2">
				<CommonImage
					src="/icons/close-icon.svg"
					alt="close"
					width={14}
					height={14}
					className="close-icon-image"
					onClick={closeModal}
				/>
			</div>
			<div className="masonry-images">{renderImageList()}</div>
			<div className="market-category-select d-flex">
				<select
					className
					name="productGroupId"
					id="productGroupId"
					onChange={(e) => setSelectedMarket(e.target.value)}
				>
					<option value={0}>Select Market</option>
					{renderMarketList()}
				</select>
				<div className="select-component category-select">
					<CustomDropdown
						title={'Category'}
						isFocus={true}
						type="addItem"
						toolTipLength={19}
						isAddNew={false}
						onItemClick={onItemClick}
						items={categoryList}
						selectedItem={selectedCategory.constant}
						isDisabled={false}
					/>
				</div>
			</div>
			{isRequestForm === 'SUPPLIER' && (
				<>
					<div className="market-category-select d-flex no-border-top">
						<div className="select-component category-select brand">
							<CustomDropdown
								title={'Brand'}
								isFocus={true}
								type="addItem"
								toolTipLength={19}
								isAddNew={false}
								onItemClick={onItemClick}
								items={brands}
								selectedItem={selectedBrand.value}
								isDisabled={false}
							/>
						</div>
						<div className="select-component category-select season">
							<CustomDropdown
								title={'Season'}
								isFocus={true}
								type="addItem"
								toolTipLength={19}
								isAddNew={false}
								onItemClick={onItemClick}
								items={seasonList}
								selectedItem={selectedSeason.value}
								isDisabled={false}
							/>
						</div>
					</div>
					<div className="market-category-select d-flex no-border-top">
						<div className="select-component category-select fabric">
							<CustomDropdown
								type="addItem"
								title={'Fabric'}
								isAddNew={false}
								onItemClick={onItemClick}
								items={allFabrics}
								selectedItem={selectedFabric.value}
								onItemSearch={onFabricSearch}
							/>
						</div>
					</div>
					<div className="market-category-select d-flex no-border-top">
						<input
							type="text"
							autoComplete="off"
							name="refNumber"
							onChange={(e) => setRefNumber(e.target.value)}
							value={refNumber}
							placeholder={'Fabric reference number'}
						/>
					</div>
				</>
			)}
			<div className="create-btn">
				<button
					onClick={createProduct}
					className="button w-100"
					disabled={selectedMarket < 1 || Object.keys(selectedCategory) < 1 || imageList.length < 1}
				>
					<img src={`${process.env.PUBLIC_URL}/icons/Leftarrwo-white.svg`} alt="left arrow" />
					CREATE
				</button>
			</div>
		</div>
	);
};

export default CreateNewProduct;
